import React, { Fragment } from "react";
import { connect } from "react-redux";
import { fetchFundDeals } from "store/state/fund";
import { Grid } from "@material-ui/core";
import { isEmpty } from "lodash";
import EmptyDeals from './EmptyDeals';
import DealLabel from './DealLabel';
import styled from 'styled-components';
import Tile from "./Tile";

const DealTilesLabel = styled.div`
  padding: 4px 0;
`
class DealsTiles extends React.Component {
  state = {};

  componentDidMount() {
    const { funds,screenType, status } = this.props;    
    this.props.fetchFundDeals({
      fundId: funds.id,
      status,
      screenType
    });
  }

  
  componentDidUpdate(prevProps, prevState) {
    const { page, rowsPerPage } = this.state;
    const { funds, status,screenType } = this.props;
    if (prevProps.funds.id !== funds.id) {
      this.props.fetchFundDeals({        
        fundId: funds.id,
        status,
        screenType
      });
    }
  }

  render() {
    const { status } = this.props;        
    const {
      fund: { deals }
    } = this.props;    
    return (
      <Fragment>        
        <DealLabel status={status}/>
        {!isEmpty(deals[status].deals) && <Grid container spacing={8}>
          
            {Object.keys(deals[status].deals).map(id => (
              <Tile
                key={id}
                deal={deals[status].deals[id]}
                status={status}
                openNotes={this.props.openNotes}
              />
            ))}            
        </Grid>}
        {isEmpty(deals[status].deals) && <EmptyDeals status={status}/>}
      </Fragment>
    );
  }
}

const mapStateToProps = ({ fund }) => ({ fund });

export default connect(
  mapStateToProps,
  { fetchFundDeals }
)(DealsTiles);
// export default DealsTiles;
